export default __webpack_public_path__ + "static/media/v-bar-stack-line.0dcfac55.svg";